import { SectionHeader, Typography } from "~/common/components";
import { TYPOGRAPHY_VARIANTS } from "~/common/utils";
import { CurrentProvider } from "../CurrentProvider";

interface HeaderInfoProps {
  subtitle?: string;
  title: string;
}

export const HeaderInfo = ({ subtitle, title }: HeaderInfoProps) => (
  <div className="flex w-full justify-between">
    <div className="flex w-full flex-col gap-2">
      {subtitle && (
        <Typography className="text-lg" variant={TYPOGRAPHY_VARIANTS.secondary}>
          {subtitle}
        </Typography>
      )}
      <SectionHeader className="text-3xl font-semibold">{title}</SectionHeader>
    </div>
    <CurrentProvider className="hidden md:flex" />
  </div>
);
